<div class="d-flex justify-content-center">
  <h4 id="page-heading">
    <span>Recettes</span>
  </h4>
  </div>
  <div class="container">
    <div class="d-flex justify-content-center">
      <div class="p-2 align-self-center">
        <svg width="200" height="100">
          <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
          <text x="100" y='20' font-size="25"
          [attr.fill]="'#148f29'" text-anchor='middle'>{{recetteM}} €</text>
          <text x="100" y='65' font-size="16" fill="#000044" text-anchor='middle'>Ce mois</text>
        </svg>
      </div>
      <div class="p-2 align-self-center">
        <svg width="200" height="100">
          <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
          <text x="100" y='20' font-size="25"
          [attr.fill]="'#148f29'" text-anchor='middle'>{{recetteJ}} €</text>
          <text x="100" y='65' font-size="16" fill="#000044" text-anchor='middle'> Aujourd'hui</text>
        </svg>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="p-3 align-self-center">
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <div class="col-auto">
      <button id="create-variable" class="btn btn-indigo" type="submit" (click)="addRib()">
        <span>
          configurer RIB
        </span>
      </button>
    </div>
    <div class="col-auto">
      <button id="create-variable" class="btn btn-indigo" type="submit" (click)="demandeVir()">
        <span>
          demander un virement
        </span>
      </button>
    </div>
    <div class="col-auto">
      <button id="create-variable" class="btn btn-indigo" type="submit" (click)="exportReleve()">
        <span>
          exporter relevé de compte
        </span>
      </button>
    </div>
  </div>
